import { type UserOrderResponseWithFlags } from '@redteclab/api/clients/bully'

const ORDER_LOOKBACK_MONTHS = 3

const getOrderDateCutoff = (currentDate: Date): Date => {
  const cutoffDate = new Date(currentDate)
  const currentDay = cutoffDate.getDate()

  cutoffDate.setDate(1)
  cutoffDate.setMonth(cutoffDate.getMonth() - ORDER_LOOKBACK_MONTHS)

  const lastDayOfCutoffMonth = new Date(
    cutoffDate.getFullYear(),
    cutoffDate.getMonth() + 1,
    0,
  ).getDate()

  cutoffDate.setDate(Math.min(currentDay, lastDayOfCutoffMonth))
  cutoffDate.setHours(0, 0, 0, 0)

  return cutoffDate
}

const getOrderDate = (order: UserOrderResponseWithFlags): Date | undefined => {
  const orderDate = order.orderMasterData?.orderDate

  if (!orderDate) {
    return undefined
  }

  const parsedOrderDate = new Date(orderDate)

  return Number.isNaN(parsedOrderDate.getTime()) ? undefined : parsedOrderDate
}

export const directContactFormAccessorGetRecentOrders = (
  orders: UserOrderResponseWithFlags[],
  currentDate = new Date(),
): {
  hasReachedLookbackBoundary: boolean
  recentOrders: UserOrderResponseWithFlags[]
} => {
  const cutoffDate = getOrderDateCutoff(currentDate)
  let hasReachedLookbackBoundary = false

  const recentOrders = orders.filter((order) => {
    const orderDate = getOrderDate(order)

    if (!orderDate) {
      return false
    }

    if (orderDate < cutoffDate) {
      hasReachedLookbackBoundary = true

      return false
    }

    return true
  })

  return { hasReachedLookbackBoundary, recentOrders }
}
